import type React from 'react';
import type { MutableRefObject, RefObject } from 'react';
import { createContext } from 'react';
import type { DSLeftNavigationT } from './react-desc-prop-types.js';
import { defaultProps } from './react-desc-prop-types.js';

export type ContextProps = {
  selectedItem: string | null;
  setSelectedItem: React.Dispatch<React.SetStateAction<string | null>>;
  selectedParent: string | null;
  setSelectedParent: React.Dispatch<React.SetStateAction<string | null>>;
  focusedItem: string | null;
  setFocusedItem: React.Dispatch<React.SetStateAction<string | null>>;
  openedDrilldowns: string[];
  setOpenedDrilldowns: React.Dispatch<React.SetStateAction<string[]>>;
  visibleItems: string[];
  visibleItemsRefs: MutableRefObject<Record<string, RefObject<HTMLDivElement>>>;
  leftNavProps: DSLeftNavigationT.InternalProps;
  expandedForAnimation: boolean;
};

export const defaultContext: ContextProps = {
  leftNavProps: defaultProps,
  selectedItem: null,
  setSelectedItem: () => null,
  selectedParent: null,
  setSelectedParent: () => null,
  focusedItem: null,
  setFocusedItem: () => null,
  expandedForAnimation: true,
  openedDrilldowns: [],
  setOpenedDrilldowns: () => null,
  visibleItems: [],
  visibleItemsRefs: { current: {} },
};

export const LeftNavContext = createContext<ContextProps>(defaultContext);

export default LeftNavContext;
